<template>
  <div>
    <my-table :title="title"
              :isAdd="isAdd"
              :searchParams="searchParams"
              :tableData="tableData"
              :isSearch="isSearch"
              @pageNumChange="pageNumChange"
              @search="search"
              @keyup.enter.native="keyup()">
      <div slot="table">
        <user-coupons-table :tableData="tableData.list" @view="view"></user-coupons-table>
      </div>
    </my-table>
  </div>
</template>

<script>
  import UserCouponsTable from "./UserCouponsTable";
  import MyTable from "../../components/content/myTable/MyTable";
  import {newVue,getUserCouponsBySearch} from "../../network/userCoupons";

  export default {
    name: "couponsList",
    components: {UserCouponsTable, MyTable},
    data(){
      return {
        title: "用户优惠券列表",
        isAdd: false,
        isSearch: true,
        //搜索条件
        searchParams:[
          {
            key:"couponsName",
            value:"优惠券名称"
          },
          {
            key:"userId",
            value:"用户id"
          },
          {
            key:"state",
            value:"优惠券状态"
          }
        ],
        //表格数据以及分页信息
        tableData: {},
        searchItems:[],
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href =  "/userCoupons/list";
      this.common.HeaderLocationTwo.name =  "用户优惠券列表"
      this.common.HeaderLocationThree.name = "用户优惠券列表"

      let couponsId = this.$route.params.couponsId;
      console.log(couponsId);
      if (couponsId!=null){
        let item = {};
        item.value = "couponsId";
        item.input = couponsId;
        this.searchItems[0] = item;
      }
      this.searchEasy(this.searchItems)
    },
    methods:{
      refresh(){
        getUserCouponsBySearch().then(res => {
          this.tableData = res.data
        })
      },
      pageNumChange(pageNum){
        this.searchEasy(this.searchItems,pageNum);
      },
      search(searchItems){
        this.searchItems = searchItems;
        this.searchEasy(searchItems)
      },
      searchEasy(searchItems,pageNum){
        let couponsId = null;
        let state = null;
        let couponsName = null;
        let userId = null;
        for (let i = 0;i<searchItems.length;i++){
          if (searchItems[i].value === "state"){
            state = searchItems[i].input
          }else if (searchItems[i].value === "couponsId"){
            couponsId = searchItems[i].input
          }else if (searchItems[i].value === "couponsName"){
            couponsName = searchItems[i].input
          }else if (searchItems[i].value === "userId"){
            userId = searchItems[i].input
          }
        }
        getUserCouponsBySearch(couponsId,state,couponsName,userId,pageNum).then(res => {
          this.tableData = res.data
        })
      },
      keyup(){
        this.searchEasy(this.searchItems);
      },
      view(id){
        this.$router.push("data/"+id)
      }
    }
  }
</script>

<style scoped>

</style>
